export const colors = {
  primary: {
    main: '#1DA1F2',
    dark: '#1a91da',
    light: '#71C9F8'
  },
  text: {
    primary: '#14171A',
    secondary: '#657786',
    disabled: '#AAB8C2'
  },
  background: {
    default: '#FFFFFF',
    secondary: '#F5F8FA',
    tertiary: '#E1E8ED'
  },
  border: '#E1E8ED',
  error: '#E0245E',
  success: '#17BF63',
  warning: '#F45D22'
}; 